module.exports = __webpack_public_path__ + "static/media/chatbot-builder.12710a94.svg";